export default "__VITE_ASSET__bd24d4e6__"